import type { FilterValues } from 'shared/types/analytics';
import db from './index';
import {
  makeDefaultAddOne,
  makeDefaultGetOne,
} from './defaultDaoFactories';

export interface ChartFiltersEntity {
  filters: FilterValues;
  _id: string;
}

export const getOne = makeDefaultGetOne<string, ChartFiltersEntity>(
  db,
  db.chartFilters,
  '_id'
);

export const add = makeDefaultAddOne<ChartFiltersEntity>(
  db,
  db.chartFilters
);
